export function shouldAttachGameEnd(isBonusRound, currentQuestionNumber, totalQuestions) {
    return !isBonusRound && currentQuestionNumber >= totalQuestions;
}

export function buildGameEndConfig(gameEnd, token, widgetId) {
    if (!gameEnd || !token) return undefined;
    return {headers: {"X-Captcha-Token": token, "X-Captcha-Action": "game_end", "X-Captcha-Widget": widgetId}};
}
